import React from "react";
import App from "./App";
import { Login, LoginWithOtp, Register, OtpVerification } from "./auth";
import { Projects, Project } from "./project";
import ErrorPage from "./error-page";
import { Catalogs, NewPersonalize, ProductPersonalize } from "./product";
import CatalogPage from "./catalog/CatalogPage";
import {
  ComingSoon,
  Modules,
  PricingPage,
  Support,
  Organizations,
  Laminates,
  LaminateCatalog,
} from "./common";
import { Order } from "./order";
import OrderCutlist from "./order/OrderCutlist";
import PriceSummary from "./project/PriceSummary";
import LabelPrinting from "./project/LabelPrinting";
import CustomLabelSheetPrint from "./project/CustomLabelSheetPrint";
import CuttingPlan from "./project/CuttingPlan";
import Assembly from "./project/Assembly";
import OrderDetails from "./project/OrderDetails";
import Sourcing from "./ops-tracker/Sourcing";
import AddOns from "./common/AddOns";
import HomePage from "./home/HomePage";
import SampleOrdersPage from "./sample_projects/SampleOrdersPage";
import SalesDashboard from "./sales/pages/SalesDashboard";
import ProspectEngagement from "./sales/pages/ProspectEngagement";
import OpsDashboard from "./dashboards/ops/pages/OpsDashboard";
import NotificationsPage from "./dashboards/NotificationsPage";
import ProductCatalog from "./catalog/ProductCatalog";
import CatalogManager from "./catalog/CatalogManager";
import CatalogDefinitionManager from "./catalog/CatalogDefinitionManager";
import Broadcasts from "./sales/pages/Broadcasts";
import MarginDashboard from "./sales/pages/MarginDashboard";
import PaymentsCreditsManager from "./project/PaymentsCreditsManager";
import MyOrders from "./order/MyOrders";
import ManageParts from "./project/ManageParts";
import CollectionsManager from "./store/CollectionsManager";
import Collection from "./store/Collection";
import ZeroBuildPage from "./home/ZeroBuildPage";

export const routes = [
  {
    path: "/zerobuild",
    element: <ZeroBuildPage />,
  },
  {
    path: "/",
    element: <App />,
    children: [
      // Existing routes
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "verify_otp",
        element: <OtpVerification />,
      },
      {
        path: "login_with_otp",
        element: <LoginWithOtp />,
      },
      {
        path: "admin_login",
        element: <Login user="admin" />,
      },
      {
        path: "register",
        element: <Register />,
      },
      {
        path: "projects",
        element: <Projects />,
      },
      {
        path: "catalog",
        element: <Catalogs />,
      },
      {
        path: "catalog-collection",
        element: <CatalogPage />,
      },
      {
        path: "sample-orders",
        element: <SampleOrdersPage />,
      },
      {
        path: "print/custom-label-sheet",
        element: <CustomLabelSheetPrint />,
      },
      {
        path: "laminates",
        element: <LaminateCatalog />,
      },
      {
        path: "projects/:projectId",
        element: <Project />,
        children: [
          { path: "cutlist", element: <></> },
          { path: "settings", element: <NewPersonalize /> },
          { path: "packages", element: <ComingSoon /> },
          {
            path: "orders/:orderId",
            element: <Order />,
            children: [
              { path: "bom", element: <PriceSummary /> },
              { path: "optimization", element: <CuttingPlan /> },
              { path: "cutlists", element: <OrderCutlist /> },
              { path: "panels", element: <LabelPrinting /> },
            ],
          },
          { path: "shipments", element: <ComingSoon /> },
          { path: "payments", element: <ComingSoon /> },
          {
            path: "rooms/:roomId/modules/:moduleId/canvas",
            element: <NewPersonalize />,
          },
          { path: "rooms/:roomId/canvas", element: <NewPersonalize /> },
          { path: "assembly", element: <Assembly /> },
          { path: "materials", element: <NewPersonalize /> },
        ],
      },
      {
        path: "projects/:projectId/add_ons",
        element: <AddOns />,
      },
      {
        path: "projects/:projectId/order_details",
        element: <OrderDetails />,
      },
      {
        path: "ops",
        element: <Sourcing />,
      },
      {
        path: "modules",
        element: <Modules />,
      },
      {
        path: "modules/:productId",
        element: <ProductPersonalize />,
      },
      {
        path: "product-prices",
        element: <PricingPage />,
      },
      {
        path: "support",
        element: <Support />,
      },
      {
        path: "admin",
        element: <Organizations />,
      },
      {
        path: "manage_laminates",
        element: <Laminates />,
      },
      {
        path: "sales/dashboard",
        element: <SalesDashboard />,
      },
      {
        path: "sales/margin",
        element: <MarginDashboard />,
      },
      {
        path: "sales/engagement",
        element: <ProspectEngagement />,
      },
      {
        path: "sales/broadcasts",
        element: <Broadcasts />,
      },
      {
        path: "dashboard/ops",
        element: <OpsDashboard />,
      },
      {
        path: "payments",
        element: <PaymentsCreditsManager />,
      },
      {
        path: "my-orders",
        element: <MyOrders />,
      },
      {
        path: "home",
        element: <HomePage />,
      },
      {
        path: "notifications",
        element: <NotificationsPage />,
      },
      {
        path: "products",
        element: <ProductCatalog />,
      },
      {
        path: "manage_parts",
        element: <ManageParts />,
      },
      {
        path: "manage/catalog",
        element: <CatalogManager />,
      },
      {
        path: "manage/catalog_definitions",
        element: <CatalogDefinitionManager />,
      },
      {
        path: "manage/collections",
        element: <CollectionsManager />,
      },
    ],
    errorElement: <ErrorPage />,
  },
];
